import { defineAppConfig } from '@zto/zpage'
import { META_APP_NAMES } from '../consts'

import type { App, AppMicroConfig } from '@zto/zpage'

/** 微应用配置 */
export default defineAppConfig<AppMicroConfig>((app: App) => {
  const { appEntries } = app.env

  return {
    apps: [
      {
        name: META_APP_NAMES.DATA_CENTER,
        singleModule: true,
        activeRule: '/data/',
        entry: appEntries[META_APP_NAMES.DATA_CENTER]
      },
      {
        name: META_APP_NAMES.DATA_CENTER2,
        singleModule: true,
        activeRule: `/${META_APP_NAMES.DATA_CENTER2}/`,
        entry: appEntries[META_APP_NAMES.DATA_CENTER2]
      },
      {
        name: META_APP_NAMES.CONFIG_CENTER,
        activeRule: '/config/',
        entry: appEntries[META_APP_NAMES.CONFIG_CENTER]
      },
      {
        name: META_APP_NAMES.KDCS_OPERATE,
        activeRule: '/kdcs/',
        entry: appEntries[META_APP_NAMES.KDCS_OPERATE]
      },
      {
        name: META_APP_NAMES.AD_OPERATE,
        activeRule: '/ad/',
        entry: appEntries[META_APP_NAMES.AD_OPERATE]
      },
      {
        name: META_APP_NAMES.YLPT_OPERATE,
        activeRule: '/ylpt/',
        entry: appEntries[META_APP_NAMES.YLPT_OPERATE]
      },
      {
        name: META_APP_NAMES.DMS_OPERATE,
        activeRule: '/dms/',
        entry: appEntries[META_APP_NAMES.DMS_OPERATE]
      },
      {
        name: META_APP_NAMES.IOT_OPERATE,
        activeRule: '/iot/',
        entry: appEntries[META_APP_NAMES.IOT_OPERATE]
      },
      {
        name: META_APP_NAMES.ZSCMKDG_OPERATE,
        activeRule: '/zscmkdg/',
        entry: appEntries[META_APP_NAMES.ZSCMKDG_OPERATE]
      },
      {
        name: META_APP_NAMES.ABOSS_OPERATE,
        activeRule: '/aboss/',
        entry: appEntries[META_APP_NAMES.ABOSS_OPERATE]
      }
    ]
  }
})
